"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.updateNotificationEmails = exports.fetchNotificationEmails = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _fromPromise = require("rxjs/observable/fromPromise");

var _of = require("rxjs/observable/of");

var _map = require("rxjs/operators/map");

var _filter = require("rxjs/operators/filter");

var _switchMap = require("rxjs/operators/switchMap");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _mergeMap = require("rxjs/operators/mergeMap");

var _take = require("rxjs/operators/take");

var _selectors = require("./selectors");

var _selectors2 = require("../Blogs/selectors");

var _API = _interopRequireDefault(require("./API"));

var _actions = require("./actions");

var _actions2 = require("../Blogs/actions");

var _reduxObservable = require("redux-observable");

var fetchNotificationEmails = function fetchNotificationEmails($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.NotificationEmailsActionTypes.LOAD_NOTIFICATION_EMAILS).pipe((0, _filter.filter)(function (action) {
    var blogId = action.payload.blogId;
    return [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED].indexOf((0, _selectors.getFetchNotificationEmailsRequestStatus)(blogId)(getState())) !== -1;
  }), (0, _switchMap.switchMap)(function (action) {
    var blogId = action.payload.blogId;
    return (0, _fromPromise.fromPromise)(_API.default.getBlogNotificationEmails({
      blogId: blogId
    })).pipe((0, _map.map)(function (emailsResponse) {
      return _actions.FetchNotificationEmails.success(emailsResponse, {
        blogId: blogId
      });
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.FetchNotificationEmails.failure(error, {
        blogId: blogId
      }));
    }), (0, _startWith.startWith)(_actions.FetchNotificationEmails.request({
      blogId: blogId
    })));
  }));
};

exports.fetchNotificationEmails = fetchNotificationEmails;

var makeAndHandleUpdateBlogNotificationsEmailRequest = function makeAndHandleUpdateBlogNotificationsEmailRequest(_ref2) {
  var blogId = _ref2.blogId,
      data = _ref2.data;
  return (0, _fromPromise.fromPromise)(_API.default.updateBlogNotificationEmails({
    blogId: blogId,
    data: data
  })).pipe((0, _map.map)(function (response) {
    return _actions.UpdateNotificationEmails.success(response, {
      blogId: blogId
    });
  }), (0, _catchError.catchError)(function (error) {
    return (0, _of.of)(_actions.UpdateNotificationEmails.failure(error, {
      blogId: blogId
    }));
  }), (0, _startWith.startWith)(_actions.UpdateNotificationEmails.request({
    blogId: blogId
  })));
};

var updateNotificationEmails = function updateNotificationEmails($action, _ref3) {
  var getState = _ref3.getState;
  return $action.ofType(_actions.NotificationEmailsActionTypes.UPDATE_NOTIFICATION_EMAILS).pipe((0, _filter.filter)(function (action) {
    var blogId = action.payload.data.blogId;
    return (0, _selectors.getUpdateNotificationEmailsRequestStatus)(blogId)(getState()) !== _RequestStatusTypes.default.PENDING;
  }), (0, _mergeMap.mergeMap)(function (action) {
    if ([_RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.UNINITIALIZED].includes((0, _selectors2.getUpdateBlogRequestStatus)(getState()))) {
      return makeAndHandleUpdateBlogNotificationsEmailRequest(action.payload.data, {
        getState: getState
      });
    }

    return $action.ofType(_actions2.UpdateBlogActionTypes.SUCCESS, _actions2.UpdateBlogActionTypes.FAILURE).pipe((0, _take.take)(1), (0, _mergeMap.mergeMap)(function () {
      return makeAndHandleUpdateBlogNotificationsEmailRequest(action.payload.data, {
        getState: getState
      });
    }));
  }));
};

exports.updateNotificationEmails = updateNotificationEmails;

var _default = (0, _reduxObservable.combineEpics)(fetchNotificationEmails, updateNotificationEmails);

exports.default = _default;